import { render } from "./MonthPicker.vue?vue&type=template&id=06c04827"
import script from "./MonthPicker.vue?vue&type=script&lang=js"
export * from "./MonthPicker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__